module.exports = __webpack_public_path__ + "img/ZeldaTitleScreen.08a49e00.png";